<div class="gallery-wrapper" [ngClass]="{ loading: loading }">
  <div class="mb-16" fxLayout="row" fxLayoutAlign="space-between start">
    <div class="card-title">Galeria de Imagens</div>
    <button class="btn btn-blue" (click)="triggerFileInput()" [disabled]="loading">Adicionar Imagens</button>
    <input hidden #fileInput type="file" (change)="onFileSelected($event)" multiple accept="image/*" />
  </div>
  <div class="gallery-container">
    <div *ngFor="let image of images; let idx = index" class="gallery-image">
      <img [src]="image.url" alt="" />
      <button class="gallery-image-delete" [disabled]="loading" (click)="removeImage(image, idx)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
